export const STAT_RING_MAX_SIZE = 80;
export const STAT_RING_MIN_SIZE = 56;

const FULL_SIZE_STROKE = 7;
// Room left beside each ring inside its share of the row, so neighbouring rings never touch.
const SLOT_MARGIN_PX = 16;

function clamp(value: number, min: number, max: number): number {
    return Math.min(max, Math.max(min, value));
}

// Ring diameter that lets `count` rings share one row of `rowWidth` px; full size until measured.
export function statRingSizeForRow(rowWidth: number, count: number, gapPx: number): number {
    if (rowWidth <= 0 || count <= 0) return STAT_RING_MAX_SIZE;
    const slot = (rowWidth - gapPx * (count - 1)) / count;
    return Math.round(clamp(slot - SLOT_MARGIN_PX, STAT_RING_MIN_SIZE, STAT_RING_MAX_SIZE));
}

export function statRingStrokeWidth(size: number): number {
    return Math.round((size * FULL_SIZE_STROKE) / STAT_RING_MAX_SIZE);
}
